import React from 'react';
import PayWhatYouWant, { DonationSuccess } from '../components/Donations/PayWhatYouWant';

const DonationPage = ({ showToast, isSuccessPage = false }) => {
  return (
    <div className="card" data-testid="donation-page">
      <div className="card-header">
        <h2>
          {isSuccessPage ? 'Donation Complete' : 'Support InfoPilot'}
        </h2>
      </div>
      
      <div style={{ padding: '20px 0' }}>
        {isSuccessPage ? (
          <DonationSuccess showToast={showToast} />
        ) : (
          <>
            <PayWhatYouWant showToast={showToast} />
            
            {/* Additional Info */}
            <div style={{
              marginTop: 30,
              padding: 20,
              background: '#475569',
              borderRadius: 12,
              border: '1px solid rgba(255,255,255,0.1)'
            }}>
              <h3 style={{ color: '#047857', marginBottom: 16, fontSize: '1.1rem' }}>
                Why Support InfoPilot?
              </h3>
              
              <div style={{ display: 'grid', gap: 16 }}>
                <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                  <span style={{ fontSize: '1.5rem' }}>🔍</span>
                  <div>
                    <h4 style={{ color: '#334155', margin: '0 0 4px 0', fontSize: '0.95rem' }}>
                      Advanced Search Tools
                    </h4>
                    <p style={{ color: '#a1a1aa', margin: 0, fontSize: '0.85rem' }}>
                      Your support helps us develop better search protocols and categorization features.
                    </p>
                  </div>
                </div>
                
                <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                  <span style={{ fontSize: '1.5rem' }}>🌐</span>
                  <div>
                    <h4 style={{ color: '#334155', margin: '0 0 4px 0', fontSize: '0.95rem' }}>
                      Free for Everyone
                    </h4>
                    <p style={{ color: '#a1a1aa', margin: 0, fontSize: '0.85rem' }}>
                      Donations keep our core features free and accessible to all users.
                    </p>
                  </div>
                </div>
                
                <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                  <span style={{ fontSize: '1.5rem' }}>🚀</span>
                  <div>
                    <h4 style={{ color: '#334155', margin: '0 0 4px 0', fontSize: '0.95rem' }}>
                      Continuous Improvement
                    </h4>
                    <p style={{ color: '#a1a1aa', margin: 0, fontSize: '0.85rem' }}>
                      Help us add new features, improve performance, and expand our capabilities.
                    </p>
                  </div>
                </div>
                
                <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                  <span style={{ fontSize: '1.5rem' }}>💜</span>
                  <div>
                    <h4 style={{ color: '#334155', margin: '0 0 4px 0', fontSize: '0.95rem' }}>
                      Earn XP & Recognition
                    </h4>
                    <p style={{ color: '#a1a1aa', margin: 0, fontSize: '0.85rem' }}>
                      Donors earn bonus XP points and get recognized in our supporter community.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* FAQ */}
            <div style={{
              marginTop: 20,
              padding: 20,
              background: 'rgba(245, 158, 11, 0.1)',
              borderRadius: 12,
              border: '1px solid rgba(245, 158, 11, 0.2)'
            }}>
              <h3 style={{ color: '#3b82f6', marginBottom: 16, fontSize: '1.1rem' }}>
                Frequently Asked Questions
              </h3>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div>
                  <h4 style={{ color: '#93c5fd', margin: '0 0 4px 0', fontSize: '0.9rem' }}>
                    Is my payment secure?
                  </h4>
                  <p style={{ color: '#a1a1aa', margin: 0, fontSize: '0.8rem' }}>
                    Yes! All payments are processed securely through Stripe, a trusted payment provider.
                  </p>
                </div>
                
                <div>
                  <h4 style={{ color: '#93c5fd', margin: '0 0 4px 0', fontSize: '0.9rem' }}>
                    Can I donate without an account?
                  </h4>
                  <p style={{ color: '#a1a1aa', margin: 0, fontSize: '0.8rem' }}>
                    Yes! Guest donations are welcome. However, logging in lets you earn XP points.
                  </p>
                </div>
                
                <div>
                  <h4 style={{ color: '#93c5fd', margin: '0 0 4px 0', fontSize: '0.9rem' }}>
                    Is my donation tax-deductible?
                  </h4>
                  <p style={{ color: '#a1a1aa', margin: 0, fontSize: '0.8rem' }}>
                    Donations to InfoPilot are not tax-deductible as we are not a registered nonprofit.
                  </p>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DonationPage;
